import React from "react";
import "../App.css";
import { connect } from "react-redux";
import "react-toastify/dist/ReactToastify.min.css";
import "react-datepicker/dist/react-datepicker.css";

class StaffPODetails extends React.Component {
    constructor(props) {
        super(props);
        this.state = {

        };

    }

    componentDidMount() {
        const { dispatch, match } = this.props;
        if (match.params.id) {
            // dispatch(getEquipmentDetails(match.params.id));
            // dispatch(getEquipmentHistory(match.params.id));
        }
    }

    ShowSidePanel = () => {
        this.props.dispatch({ type: "ShowPODetail", data: false });
        // this.props.history.push("/Home/StaffInfo");
        this.props.history.goBack();
    };

    render() {
        const { equipmentDetail } = this.props;
        return (
            <div className="row">
                <div className="full-height pt-3">
                    <div className="grey-bg course-list-page">
                        <div className="panel-box search-filter-box mb-4">
                            <button className="btn btn-primary text-uppercase txtside-btn txtht-btn blue" onClick={() => this.ShowSidePanel()} >
                                &larr; Return
                            </button>

                            <div className="resource-list-auth-date">
                                <div className="card mt-2 MM-card-header" style={{ backgroundColor: "white" }} >
                                    <div className="card-body">
                                        <h5 className="card-title ml-2 mt-2" style={{ color: "092a51" }}>
                                            PO Details
                                        </h5>
                                    </div>
                                    <div className="search-filter-box mt-2">
                                        <div className="row">
                                            <div className="col-sm-6 mb-2">
                                                <span>
                                                    <strong>SNo: </strong>
                                                    <span>{this.props.equipmentDetail.sNo}</span>
                                                </span>
                                            </div>
                                            <div className="col-sm-6 mb-2">
                                                <span>
                                                    <strong>Line item Description: </strong>
                                                    <span>{this.props.equipmentDetail.lineitemdesc}</span>
                                                </span>
                                            </div>
                                            <div className="col-sm-6 mb-2">
                                                <span>
                                                    <strong>Make: </strong>
                                                    <span>{this.props.equipmentDetail.make}</span>
                                                </span>
                                            </div>
                                            <div className="col-sm-6 mb-2">
                                                <span>
                                                    <strong>Model: </strong>
                                                    <span>{this.props.equipmentDetail.model}</span>
                                                </span>
                                            </div>
                                            <div className="col-sm-6 mb-2">
                                                <span>
                                                    <strong> Qty: </strong>
                                                    <span>{this.props.equipmentDetail.qty}</span>
                                                </span>
                                            </div>
                                            <div className="col-sm-6 mb-2">
                                                <span>
                                                    <strong> IHM Presense: </strong>
                                                    <span>{this.props.equipmentDetail.IHMpresense}</span>
                                                </span>
                                            </div>
                                            <div className="col-sm-6 mb-2">
                                                <span>
                                                    <strong> MD: </strong>
                                                    <span>{this.props.equipmentDetail.md}<i className="fa fa-download click ml-1"></i></span>
                                                </span>
                                            </div>
                                            <div className="col-sm-6 mb-2">
                                                <span>
                                                    <strong> SDoC: </strong>
                                                    <span>{this.props.equipmentDetail.sdoc}<i className="fa fa-download click ml-1"></i></span>
                                                </span>
                                            </div>
                                            <div className="col-sm-6 mb-2">
                                                <span>
                                                    <strong> Download Report: </strong>
                                                    <span>{this.props.equipmentDetail.downloadreport}<i className="fa fa-download click ml-1"></i></span>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    };
}
function mapStateToProps(state) {
    return {
        // MIEuList: state.SidePanReducer.MIEuList,
        equipmentDetail: {
            "sNo": 1,
            "lineitemdesc": "Desc of the item",
            "make": "Make",
            "model": "CF Model",
            "qty": 55,
            "md": "aaa.doc",
            "sdoc": "bbb.doc",
            "IHMpresense": "Yes",
            "downloadreport": "ccc.pdf",
        },
        // equipmentHistory: state.ShipEquipmentReducer.EquipmentHistory || [],
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(StaffPODetails);
